export const parseBooleanToBinary = (isTrue: boolean) =>
    isTrue ? 1 : 0;
